import React from 'react';
import { get } from 'lodash';
import { IconProfile, IconCorporate } from '@tokenyico/tokeny-ui';
import countries from 'assets/data/countries.json';
import occupations from 'assets/data/occupations-activities.json';
import { getAddress } from 'viem';

export function getInvestorName(holder) {
  if (holder.typeOfInvestor === 'individual') {
    if (get(holder, 'individual.firstName', '') === null) return '-';
    return `${get(holder, 'individual.firstName', '')} ${get(holder, 'individual.lastName', '')}`;
  }

  if (holder.typeOfInvestor === 'institution') {
    if (get(holder, 'institutional.institutionLegalName') === null) return '-';
    return `${get(holder, 'institutional.institutionLegalName', '')}`;
  }

  return '-';
}

export function TypeOfInvestorIcon({ investor, size = 22 }) {
  if (investor.typeOfInvestor === 'individual') {
    return <IconProfile color="black" size={size} />;
  }

  if (investor.typeOfInvestor === 'institution') {
    return <IconCorporate color="black" size={size} />;
  }

  return '-';
}

// type = name, alpha-2, alpha-3, country-code
export function getCountryBy(country, type = 'alpha-3') {
  return countries.find((c) => c[type] === country);
}

export function getOccupation(occupation) {
  return occupations.find((c) => c['name'] === occupation);
}

export function getPep({ investor }) {
  let politicallyExposed;

  if (investor.typeOfInvestor === 'individual') {
    if (investor.individual.politicallyExposed == null) {
      politicallyExposed = '-';
    } else {
      if (typeof investor.individual.politicallyExposed === 'boolean') {
        politicallyExposed = investor.individual.politicallyExposed ? 'Yes' : 'No';
      } else {
        politicallyExposed = investor.individual.politicallyExposed;
      }
    }
  }

  return politicallyExposed;
}

export function getProvider({ wallets, searchFor }) {
  return wallets.find((w) => w.identityRegistryStorage === searchFor);
}
export function toChecksumAddress(wallet) {
  return getAddress(wallet);
}
